export default __webpack_public_path__ + "static/media/None.692f148a.png";